export default __webpack_public_path__ + "static/media/exclamation-mark.90e77427.svg";